import { ADMIN_BFF_URL } from "environment";
import { IScheduleWindow } from "interfaces";
import { axiosInstance } from "./axios";

export async function uploadExecutionFile({
  file,
  shootId,
}: {
  file: File;
  shootId: string;
}): Promise<any> {
  const formData = new FormData();
  formData.append("file", file);

  const response = await axiosInstance.post(
    ADMIN_BFF_URL + `/v1/disparo-leads/upload/${shootId}`,
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );

  return response.data;
}

export function executeShoot({ shootId }: { shootId: string }): Promise<void> {
  return axiosInstance.post(
    ADMIN_BFF_URL + `/v1/campaign-executions/${shootId}/execute `
  );
}

export async function getScheduleWindow({
  start,
  end,
}: {
  start: string;
  end: string;
}): Promise<IScheduleWindow> {
  const params = new URLSearchParams();
  params.append("start", start);
  params.append("end", end);

  const response = await axiosInstance.get(
    ADMIN_BFF_URL + `/v1/schedule-window/?${params.toString()}`
  );

  return response.data;
}
